export function teaserText(text: string, size: number): string {
  if (typeof text !== 'string') {
    console.warn('teaserText received non-string value:', text);
    return '';
  }
  if (text.length <= size) {
    return text;
  }
  return text.substring(0, size) + '...';
}
// Met en majuscule la première lettre d'une chaîne
const ucFirst = (string: string): string => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

// Met en majuscule la première lettre de chaque mot, même séparés par des tirets
export const ucWords = (string: string): string => {
  if (!string) return '';

  // Traiter les espaces et les tirets comme séparateurs de mots
  return string
    .split(/[\s-]+/)
    .map(word => ucFirst(word))
    .join(' ');
};

// Token replacement using recipient shortcuts
import type { EmailRecipient } from '@/utils/recipient';
import { recipientToTokenVars } from '@/utils/recipient';

export function applyTokens(input: string, vars: Record<string, string>): string {
  if (typeof input !== 'string' || !input) return '';
  return input.replace(/\{\{\s*([a-zA-Z0-9._-]+)\s*\}\}/g, (_match, key: string) => {
    const val = vars[key];
    return typeof val === 'string' ? val : '';
  });
}

export function applyTokensWithRecipient(
  input: string,
  recipient: EmailRecipient | Record<string, unknown> | null | undefined
): string {
  const vars = recipientToTokenVars((recipient || {}) as Record<string, unknown>);
  return applyTokens(input, vars);
}
